module.exports = __webpack_public_path__ + "media/locales/_fr-50b890f0.png";